import React from 'react';
import { SFBrainHeadProfile } from 'sf-symbols-lib/monochrome/SFBrainHeadProfile';
import { SFFigureRun } from 'sf-symbols-lib/monochrome/SFFigureRun';
import { SFWaveformPathEcg } from 'sf-symbols-lib/monochrome/SFWaveformPathEcg';
import RevealBlock from '../components/RevealBlock';
import SectionIntro from '../components/SectionIntro';
import './QuickToolsSection.css';

const tools = [
  ['amber', <SFBrainHeadProfile />, 'Focus Primer', '4 min', 'Settle your attention before studying, writing, or deep work.'],
  ['coral', <SFFigureRun />, 'Pre-Workout', '2 min', 'Get alert and ready before training without feeling gassed early.'],
  ['teal', <SFWaveformPathEcg />, 'Post-Workout', '5 min', 'Bring heart rate, breathing, and arousal back down after intensity.'],
  ['violet', '☾', 'Sleep Wind-Down', '4 min', 'Ease your nervous system into a lower-arousal night state.'],
];

function QuickToolsSection() {
  return (
    <RevealBlock className="ayro-section ayro-section--tools" aria-labelledby="tools-heading">
      <SectionIntro kicker="Quick tools" kickerTone="coral" title="Quick sessions for immediate effect." headingId="tools-heading">
        These targeted tools are for you to use whenever you need. You should feel the effects as you complete these sessions.
      </SectionIntro>
      <div className="ayro-toolsGrid" aria-label="Ayro quick tools">
        {tools.map(([tone, icon, name, duration, description]) => (
          <article className="ayro-toolCard" key={name}>
            <div className={`ayro-toolCard__icon ayro-toolCard__icon--${tone}`} aria-hidden="true">{icon}</div>
            <div className="ayro-toolCard__top">
              <h3>{name}</h3>
              <span>{duration}</span>
            </div>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </RevealBlock>
  );
}

export default QuickToolsSection;
